"use strict";

import * as commonFuns from "./modules/styles/styles-functions";

(function ($) {
    $(document).ready(function () {
        let menuItems = $("#menu-main-menu > li");

        // For Menu
        $("#nav-full-box").on("shown.bs.collapse", (e) => {
            $("body").addClass("menu-collapse");
            if ($(document).width() < 768) {
                $("html").addClass("none-scroll");
                $("body").addClass("none-scroll");
            }
            setTimeout(function () {
                setheightMenuMobile();
            }, 600);

            $(".hamburger").addClass("is-active");
        });

        $("#nav-full-box").on("hidden.bs.collapse", (e) => {
            $("body").removeClass("menu-collapse");
            if ($(document).width() < 768) {
                $("html").removeClass("none-scroll");
                $("body").removeClass("none-scroll");
            }

            $(".hamburger").removeClass("is-active");
            menuItems.find(".sub-menu").hide();
        });

        $("#toggle-nav-main-open").on("click", function (event) {
            event.preventDefault();
        });

        $(".video-source").click(function () {
            let video = $(this)[0];
            if (video.paused) {
                video.play();
            } else {
                video.pause();
            }
        });

        menuItems.each(function (index, el) {
            if ($(this).find(".sub-menu").children().length > 0) {
                $(this).append($(this).find("ul"));

                $(this).attr("data-href", $(this).children("a").attr("href"));
                $(this).children("a").removeAttr("href");
                $(this).find(".sub-menu").hide();
            }
        });

        menuItems.on("click", function (event) {
            let that = this;

            let activedMenu = menuItems.filter(".active");
            activedMenu.each(function (idx, elm) {
                if (that != elm) {
                    toggleMenuItem($(elm));
                }
            });

            toggleMenuItem($(that));
        });

        videoSourceControl();

        try {
            $(".scrollbar-info").each(function (index) {
                new SimpleBar($(this)[0], {
                    scrollbarMinSize: 1,
                    autoHide: false,
                    // forceVisible: 'y'
                }).recalculate();
            });
        } catch (e) {
            console.log(e);
        }

        $(".expand-content").each(function (index) {
            new SimpleBar($(this)[0], {
                scrollbarMinSize: 1,
                autoHide: false,
                // forceVisible: 'y'
            }).recalculate();
        });

        if (commonFuns.checkIsLandscape()) {
            $("body").addClass("is-landscape");

            let clone = $(".logo__").clone();

            clone.addClass("logo_relative");

            clone.insertBefore($("#header"));
        } else {
        }

        try {
            SimpleBar.removeObserver();
        } catch (e) {}
    });

    $(window).resize(function () {
        if ($(document).width() < 768) {
            $("html").addClass("none-scroll");
            $("body").addClass("none-scroll");
        }

        setTimeout(function () {
            setheightMenuMobile();
        }, 600);

        videoSourceControl();
    });

    function setheightMenuMobile() {
        let menu = $("#primary-menu");
        if (
            $(document).width() < 768 &&
            menu.height() > $(window).height() - 92
        ) {
            menu.css({
                height: "calc(100vh - 92px)",
                "overflow-y": "scroll",
            });
        } else {
            menu.removeAttr("style");
        }
    }

    function toggleMenuItem(menu) {
        if ($(window).width() > 767) {
            if (menu.find(".sub-menu").children().length > 0) {
                if (menu.hasClass("active")) {
                    menu.find(".sub-menu").slideUp("fast");
                    menu.removeClass("active");
                } else {
                    menu.addClass("active");
                    menu.find(".sub-menu").slideDown("fast");
                }
            }
        }
    }

    function videoSourceControl() {
        $(".video-source").each(function () {
            let video = $(this);
            if (video.prop("controls") && video.height() > $(window).height()) {
                video.addClass("control-always-bottom");
                video
                    .closest(".full_screen-video-source")
                    .css("height", "100vh");
            } else {
                video.removeClass("control-always-bottom");
                video.closest(".full_screen-video-source").removeAttr("style");
            }
        });
    }
})(jQuery);

$(document).ready(function () {
    $(".lightbox-images").fancybox();
});
